import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
:root {
    --maxWidth : 1280px;
    --white: #f4f4f4;
    --lightGrey: #7a7a7a;
    --medGrey: #494949;
    --darkGrey: #313131;
    --fontSuperBig: 2.441rem;
    --fontBig: 1.563rem;
    --fontMed: 1.25rem;
    --fontSmall:1rem;

    }
    
    * {
        box-sizing: border-box;
        font-family: "Open Sans", sans-serif;
        padding: 0; margin: 0;
    }

    body { 
    background-color: #f4f4f4;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    position: relative;


    h1 {
        font-size: var(--fontSuperBig);
        font-weight: 700;
        color:var(---darkGrey)
    }

    h3 {
        font-size: var(---fontMed);
        font-weight: 700;
    }

    p {
        font-size: var(---fontSmall);
    }
    }
    `;
